module.exports = __webpack_public_path__ + "static/media/editar.229c209f.svg";